import { searchEcFormBuilderController } from '../../controller/searchEcFormBuilderController';

fbListDirective.$inject = ['$compile'];

export default function fbListDirective($compile) {
  return {
    restrict: 'E',
    scope: {
      fbFlash: '=',
    },
    require: '^^?ecFormBuilder',
    compile,
  };

  function compile(element, attrs) {
    const elem = element[0],
      template = elem.innerHTML;
    //
    elem.style.display = 'block';
    attrs.$set('template', template);
    elem.innerHTML = '';
    return link;
  }

  function link(scope, element, attrs, ecFormBuilderController) {
    // @odeniel 29/11/2019 INI - necesitamos buscar el ecFormBuilderController con searchEcFormBuilderControllerParent
    // para cuando se usa en una celda popup del grid :
    ecFormBuilderController = ecFormBuilderController || searchEcFormBuilderController(scope);
    // @odeniel 29/11/2019 FIN

    const model = attrs.parent; // get parent
    const newScope = scope.$new(true, scope);

    ecFormBuilderController.bind(newScope, model);

    const ngDisabledAttribute = typeof attrs.ngDisabled === 'undefined' || attrs.ngDisabled === '' ? '' : `ng-disabled="${attrs.ngDisabled}"`;
    const toolbarAttribute = typeof attrs.toolbar === 'undefined' || attrs.toolbar === '' ? '' : `toolbar='${attrs.toolbar}'`;
    const disabledAttribute = attrs.hasOwnProperty('disabled') ? `disabled` : '';

    const elem = element[0];
    elem.innerHTML = `
      <ec-grid-list2 ec-flex="8"
        ng-model="${attrs.data}"
        register-name="${attrs.model}"
        empty-line-json='${attrs.emptyLineJson}'
        max="${attrs.max}"
        min="${attrs.min}"
        ${ngDisabledAttribute}
        ${toolbarAttribute}
        ${disabledAttribute}>
          ${attrs.template}
      </ec-grid-list2>`;

    $compile(element.contents())(newScope);

    scope.$on('$destroy', () => {
      newScope && newScope.$destroy();
    });

    // protegemos para por ej cuando es una celda list, el attributo fbFlash es undefined (pasamos directamente via el elemento)
    if (attrs.fbFlash && attrs.fbFlash !== 'undefined') {
      scope.fbFlash = params => {
        elem?.firstElementChild?.flash?.(params);
      };
    }
  }
}
